import { c as _c } from "react/compiler-runtime";
import { EmblaCarouselType } from "embla-carousel";
import React, { useCallback, useEffect, useState } from "react";
export const usePrevNextButtons = (emblaApi, onButtonClick) => {
  const $ = _c(15);
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  let t0;
  if ($[0] !== emblaApi || $[1] !== onButtonClick) {
    t0 = () => {
      if (!emblaApi) {
        return;
      }
      emblaApi.scrollPrev();
      if (onButtonClick) {
        onButtonClick(emblaApi);
      }
    };
    $[0] = emblaApi;
    $[1] = onButtonClick;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onPrevButtonClick = t0;
  let t1;
  if ($[3] !== emblaApi || $[4] !== onButtonClick) {
    t1 = () => {
      if (!emblaApi) {
        return;
      }
      emblaApi.scrollNext();
      if (onButtonClick) {
        onButtonClick(emblaApi);
      }
    };
    $[3] = emblaApi;
    $[4] = onButtonClick;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onNextButtonClick = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = emblaApi_0 => {
      setPrevBtnDisabled(!emblaApi_0.canScrollPrev());
      setNextBtnDisabled(!emblaApi_0.canScrollNext());
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onSelect = t2;
  let t3;
  let t4;
  if ($[7] !== emblaApi) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect(emblaApi);
      emblaApi.on("reInit", onSelect).on("select", onSelect);
    };
    t4 = [emblaApi, onSelect];
    $[7] = emblaApi;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== nextBtnDisabled || $[11] !== onNextButtonClick || $[12] !== onPrevButtonClick || $[13] !== prevBtnDisabled) {
    t5 = {
      prevBtnDisabled,
      nextBtnDisabled,
      onPrevButtonClick,
      onNextButtonClick
    };
    $[10] = nextBtnDisabled;
    $[11] = onNextButtonClick;
    $[12] = onPrevButtonClick;
    $[13] = prevBtnDisabled;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export const PrevButton = props => {
  const $ = _c(7);
  let children;
  let restProps;
  if ($[0] !== props) {
    ({
      children,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = restProps;
  } else {
    children = $[1];
    restProps = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="embla__button__svg" viewBox="0 0 532 532"><path fill="currentColor" d="M355.66 11.354c13.793-13.805 36.208-13.805 50.001 0 13.785 13.804 13.785 36.238 0 50.034L201.22 266l204.442 204.61c13.785 13.805 13.785 36.239 0 50.044-13.793 13.796-36.208 13.796-50.002 0a5994246.277 5994246.277 0 0 0-229.332-229.454 35.065 35.065 0 0 1-10.326-25.126c0-9.2 3.393-18.26 10.326-25.2C172.192 194.973 332.731 34.31 355.66 11.354Z" /></svg>;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== restProps) {
    t1 = <button className="embla__button embla__button--prev" type="button" {...restProps}>{t0}{children}</button>;
    $[4] = children;
    $[5] = restProps;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export const NextButton = props => {
  const $ = _c(7);
  let children;
  let restProps;
  if ($[0] !== props) {
    ({
      children,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = restProps;
  } else {
    children = $[1];
    restProps = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="embla__button__svg" viewBox="0 0 532 532"><path fill="currentColor" d="M176.34 520.646c-13.793 13.805-36.208 13.805-50.001 0-13.785-13.804-13.785-36.238 0-50.034L330.78 266 126.34 61.391c-13.785-13.805-13.785-36.239 0-50.044 13.793-13.796 36.208-13.796 50.002 0 22.928 22.947 206.395 206.507 229.332 229.454a35.065 35.065 0 0 1 10.326 25.126c0 9.2-3.393 18.26-10.326 25.2-45.865 45.901-206.404 206.564-229.332 229.52Z" /></svg>;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== restProps) {
    t1 = <button className="embla__button embla__button--next" type="button" {...restProps}>{t0}{children}</button>;
    $[4] = children;
    $[5] = restProps;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};